export const log_in = () => (
  <path
    d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4m-5-4l5-5m0 0l-5-5m5 5H3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
